import api from '../../api';

export const getCourses = async () => {
  const options = {
    method: 'get',
    url: '/course',
    withCredentials: true
  }
  const result = await api(options);
  return result?.data ? result.data : null;
}

export const getCourseIds = async () => {
  const courses = await getCourses();
  const ids = [];
  courses.forEach(course => {
    const { id, accessible } = course;
    if (accessible) ids.push(id);
  });
  return ids;
}

export const getCourseSections = async (courseId) => {
  const options = {
    method: 'get',
    url: `/course/element?courseId=${courseId}`,
    withCredentials: true
  }
  const result = await api(options);
  return result?.data ? result.data : null;
}

export const getSection = async (id) => {
  const options = {
    method: 'get',
    url: `/segment/${id}`,
    withCredentials: true
  }
  const result = await api(options);
  return result?.data ? result.data : null;
}

export const getGameset = async (id) => {
  const options = {
    method: 'get',
    url: `/course/gameSet/${id}`,
    withCredentials: true
  }
  const result = await api(options);
  return result?.data ? result.data : null;
}

export const getHistory = async (id) => {
  const options = {
    method: 'get',
    url: getExerciseUrl('HISTORY', 'presentation', id),
    withCredentials: true
  }
  const result = await api(options);
  return result?.data ? result.data : null;
}

export const getExercise = async (type, elementType, exerciseId) => {
  const options = {
    method: 'get',
    url: getExerciseUrl(type, elementType, exerciseId),
    withCredentials: true
  }
  const result = await api(options);
  return result?.data ? result.data : null;
}

export function getExerciseUrl(type, elementType, exerciseId) {
  // type: presentation
  // elementType: HISTORY
  let url = '/course/' + elementType.toLowerCase() + '/';
  if (type) url += type + '/';
  url += exerciseId;
  return url;
}

export const getExerciseImages = async (type, elementType, exerciseId) => {
  const exercise = await getExercise(type, elementType, exerciseId);
  return exercise.map(slide => slide.imageUrl);
}

export const getSectionHistoryImages = async (sectionId) => {
  const section = await getSection(sectionId);
  const exercise = section.find(s => s.type === 'HISTORY');
  const images = await getExerciseImages('HISTORY', 'presentation', exercise.id);
  return images;
}

export const getCourseHistoryImages = async (courseId) => {
  const courseSections = await getCourseSections(courseId);
  const exerciseSections = courseSections.filter(s => s.type === 'SEGMENT');
  const sectionIds = exerciseSections.map(s => s.id);
  let images = [];
  await asyncForEach(sectionIds, async (sectionId) => {
    const historyImages = await getSectionHistoryImages(sectionId);
    images = [...images, ...historyImages];
  })
  return images;
}

export const getAllHistoryImages = async () => {
  const courseIds = await getCourseIds();
  let images = [];
  await asyncForEach(courseIds, async (courseId) => {
    const courseImages = await getCourseHistoryImages(courseId);
    images = [...images, ...courseImages];
  });
  return images;
}

export const asyncForEach = async (array, callback) => {
  if (!array) return;
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};